// Mock data for portfolio

export const personalInfo = {
  name: "Ammar Alkhalissi",
  title: "Electrical Engineering Student",
  tagline: "I design and build embedded systems for real-time sensing, data acquisition, and automotive applications",
  cta: "Actively seeking 2026/2027 internships in the engineering industry",
  email: "ammaralk@umich.edu",
  phone: "(313) 652-6130",
  linkedin: "https://www.linkedin.com/in/ammar-alkhalissi",
  github: "https://github.com/A2C146",
  location: "Dearborn, MI",
  citizenship: "US Citizen",
  profileImage: "https://customer-assets.emergentagent.com/job_portfolio-showcase-1215/artifacts/a8hplxj6_Professional%20Image.jpeg",
  resumeUrl: "/resume.pdf"
};

export const aboutMe = {
  description: "I'm an Electrical Engineering student at the University of Michigan–Dearborn focused on embedded systems, real-time data acquisition, and automotive diagnostics. I've built systems ranging from autonomous vehicles to flight data loggers, combining hardware design with software development. I enjoy solving complex engineering problems and building systems that work reliably in real-world environments.",
  highlights: [
    "Embedded Systems & IoT Development",
    "Automotive Diagnostics (OBD-II)",
    "Arduino & Microcontroller Programming",
    "Circuit Analysis & Troubleshooting",
    "Web Development (JavaScript, HTML, CSS, Java)"
  ]
};

export const technicalSkills = {
  "Languages": ["C", "C++", "Python", "Java", "JavaScript", "HTML/CSS"],
  "Hardware": ["Arduino", "Teensy 4.1", "PCB Design", "IR Sensors", "Piezoelectric Sensors", "Accelerometers"],
  "Tools": ["Git & GitHub", "MATLAB", "IntelliJ", "KiCad", "OBD-II Scanners"],
  "Protocols": ["SPI", "I2C", "UART", "CAN", "PWM"],
  "Systems": ["Embedded Systems", "Signal Processing", "Data Acquisition", "Motor Control", "Power Management"]
};

export const experience = [
  {
    id: 1,
    title: "Multi-Disciplinary Engineer",
    company: "MASA Rocketry Team - University of Michigan",
    location: "Dearborn, MI",
    period: "Oct. 2025 - Present",
    images: [
      "https://customer-assets.emergentagent.com/job_portfolio-showcase-1215/artifacts/2ae7uhh3_Image%20%282%29.jpg",
      "https://customer-assets.emergentagent.com/job_portfolio-showcase-1215/artifacts/dhm5f58t_Image%20%281%29.jpg"
    ],
    description: [
      "Contribute across Electrical and Mechanical subteams, supporting payload development and airframe manufacturing for competitive rocketry",
      "Develop a payload piezoelectric data logger system sampling at 3300 Hz, capturing data points per flight for vibration and power analysis",
      "Design and implement signal conditioning circuitry with analog filtering to process piezoelectric sensor outputs with <5% noise",
      "Assist with airframe mechanical manufacturing, including precision fabrication and finishing of fins",
      "Ensure structural alignment, durability testing, and aerodynamic accuracy of rocket components for stable flight performance"
    ]
  },
  {
    id: 2,
    title: "Website Developer",
    company: "Pricewatchpro.com - Independent Project with YaYa Apps",
    location: "Dearborn, MI",
    period: "Aug. 2025 - Present",
    images: [
      "https://customer-assets.emergentagent.com/job_portfolio-showcase-1215/artifacts/bxwxgvdj_image.png"
    ],
    description: [
      "Collaborate using Git & GitHub for version control, issue tracking, task management, and code review workflows",
      "Build and deploy JAR files in IntelliJ for server deployment of PriceWatchPro web application updates",
      "Implement a local development environment via localhost for rapid testing and debugging of code changes",
      "Develop new blog features and enhance site functionality using JavaScript, HTML, CSS, and Java, improving user engagement by 15%"
    ]
  }
];


export const projects = [
  {
    id: 1,
    title: "MASA Rocketry - Payload Piezoelectric Data Logger System",
    period: "Oct. 2025 - Present",
    institution: "University of Michigan-Dearborn",
    images: [
      "https://customer-assets.emergentagent.com/job_portfolio-showcase-1215/artifacts/hg982gt0_image.png",
      "https://customer-assets.emergentagent.com/job_portfolio-showcase-1215/artifacts/90ixilfc_image.png",
      "https://customer-assets.emergentagent.com/job_portfolio-showcase-1215/artifacts/plxxo009_image.png"
    ],
    description: "As part of the MASA Rocketry Team at the University of Michigan–Dearborn, I designed and developed a sophisticated payload data acquisition system for real-time flight data collection and analysis. The system integrates three piezoelectric sensors, a high-data-rate 3-axis accelerometer, and custom signal conditioning circuitry to capture vibration and power generation data at a 3300 Hz sampling rate throughout rocket flight.",
    achievements: [
      "Designed a complete PCB system with Teensy 4.1 microcontroller, ISM330DHCX 3-axis accelerometer (±16g range), and three piezoelectric plates",
      "Developed a custom analog filter circuit to condition piezoelectric signals, achieving <5% noise",
      "Implemented a real-time data acquisition system sampling at 3300 Hz, capturing data points per flight across three axes for comprehensive vibration analysis",
      "Integrated SD card storage with FAT32 filesystem supporting 8+ GB capacity for post-flight data analysis and long-duration flight logging",
      "Designed a signal conditioning circuit with a precision ADC input and SPI communication for an accelerometer interface",
      "Analyzed tri-axial vibration data to extract acceleration 'footprint' and characterize rocket structural response across X, Y, Z axes during flight phases"
    ],
    skills: ["Embedded Systems", "PCB Design (KiCad)", "Signal Processing", "Data Acquisition", "Piezoelectric Sensors", "Accelerometer Integration", "Analog Circuit Design", "Teensy 4.1 (ARM Cortex-M7)", "SPI Communication", "Power Management", "C/C++ Programming"]
  },
  {
    id: 2,
    title: "Autonomous Line Following Vehicle – E100 Engineering Project",
    period: "Aug 2025 – Dec 2025",
    institution: "University of Michigan-Dearborn",
    images: [
      "https://customer-assets.emergentagent.com/job_portfolio-showcase-1215/artifacts/c45hfd58_PIPE%20event.jpg",
      "https://customer-assets.emergentagent.com/job_portfolio-showcase-1215/artifacts/9bxl4m3r_E100%20Car%20image.jpeg",
      "https://customer-assets.emergentagent.com/job_portfolio-showcase-1215/artifacts/nqt0cnhh_image.png"
    ],
    description: "For my E100 Engineering course, I designed and programmed an autonomous line-following vehicle using 2 IR sensors, Arduino-based microcontroller, and custom PID control algorithm. The system integrates hardware and real-time software to achieve precise line tracking with 75%+ track completion accuracy.",
    achievements: [
      "Developed a PID control algorithm achieving ±2cm line-tracking accuracy across curved and straight track sections",
      "Solved sensor calibration challenges, reducing inconsistent readings by 80% through adaptive thresholding and noise filtering",
      "Implemented motor control logic with H-bridge driver and PWM outputs (0-255 duty cycle), enabling smooth speed regulation and turning",
      "Resolved motor stalling at junctions through base-speed override logic, improving junction navigation success rate from 40% to 75%",
      "Received Certification of Recognition from Team 5G for best performance in ENGR 100 at the Promoting Innovation in Project-Based Education event"
    ],
    skills: ["Embedded Systems", "Arduino", "PID Control", "IR Sensors", "H-Bridge Motor Driver", "PWM Control", "C++ Programming", "Sensor Calibration"]
  },
  {
    id: 3,
    title: "Automotive Electrical Diagnostics - OBD-II System Repairs",
    period: "Jan 2025 – Aug 2025",
    institution: "Independent Automotive Projects",
    images: null,
    description: "Completed three independent automotive electrical diagnostic and repair projects using OBD-II scanning tools and systematic troubleshooting methodologies. Diagnosed and resolved critical system faults in A/C cooling, blind spot monitoring (ADAS), and engine thermal management systems, demonstrating expertise in automotive electrical systems and sensor diagnostics.",
    achievements: [
      "A/C System Repair: Diagnosed P0128 fault code (Coolant Thermostat Below Regulating Temperature) using OBD-II scanner, identified faulty thermostat causing inadequate cooling, replaced component, and verified system restoration with 100% cooling function recovery",
      "Blind Spot Monitoring Repair: Identified C1525-92 fault (Left Rear Blind Spot Sensor Internal Fault) through OBD-II diagnostics, replaced malfunctioning sensor module, and verified proper ADAS system operation with zero false positives post-repair",
      "Engine Overheating Repair: Detected P0128 thermostat malfunction causing engine temperature >210°F, performed root cause analysis, replaced thermostat assembly, and confirmed correct operating temperature (195-205°F), preventing overheating damage",
      "Utilized advanced OBD-II diagnostic procedures, including live data monitoring, freeze frame analysis, and component-level fault isolation across 3 vehicle systems"
    ],
    skills: ["OBD-II Diagnostics", "Automotive Electrical Systems", "Sensor Diagnostics", "Fault Code Analysis", "ADAS Systems", "Thermal Management", "Root Cause Analysis", "Component Replacement"]
  }
];
export const education = [
  {
    id: 1,
    institution: "University of Michigan",
    degree: "Bachelor of Engineering in Electrical Engineering",
    location: "Dearborn, MI",
    period: "Aug. 2025 – May 2028",
    gpa: null
  },
  {
    id: 2,
    institution: "Henry Ford College",
    degree: "Pre-Engineering",
    location: "Dearborn, MI",
    period: "Aug. 2022 - Aug. 2025",
    gpa: "3.8"
  }
];

export const certifications = [
  {
    id: 1,
    name: "Introduction to Cybersecurity Careers",
    issuer: "IBM",
    date: "Aug. 2025",
    image: "https://customer-assets.emergentagent.com/job_portfolio-showcase-1215/artifacts/fkcw8sqc_image.png"
  },
  {
    id: 2,
    name: "Introduction to Software Engineering",
    issuer: "IBM",
    date: "Aug. 2025",
    image: "https://customer-assets.emergentagent.com/job_portfolio-showcase-1215/artifacts/a3v8b28p_image.png"
  },
  {
    id: 3,
    name: "Foundations of Cybersecurity",
    issuer: "Google",
    date: "Aug. 2025",
    image: "https://customer-assets.emergentagent.com/job_portfolio-showcase-1215/artifacts/ogzb2dlm_image.png"
  },
  {
    id: 4,
    name: "Introduction to Software Defined Vehicles",
    issuer: "digital.auto",
    date: "Sept. 2025",
    image: "https://customer-assets.emergentagent.com/job_portfolio-showcase-1215/artifacts/y101m5nb_image.png"
  },
  {
    id: 5,
    name: "Electrical Equipment Maintenance, Testing & Troubleshooting",
    issuer: "Udemy",
    date: "Sept. 2025",
    image: "https://customer-assets.emergentagent.com/job_portfolio-showcase-1215/artifacts/lbplo2vd_image.png"
  },
  {
    id: 6,
    name: "Intro to Automotive Functional Safety (ISO26262)",
    issuer: "Udemy",
    date: "Oct. 2025",
    image: "https://customer-assets.emergentagent.com/job_portfolio-showcase-1215/artifacts/0auacjvl_image.png"
  },
  {
    id: 7,
    name: "Automotive Diagnostics & OBD CAN Bus, UDS & ECU Fault Find",
    issuer: "Udemy",
    date: "May 2026",
    image: "https://customer-assets.emergentagent.com/job_portfolio-showcase-1215/artifacts/0j80m8un_image.png"
  }
];

export const skills = {
  "Embedded Systems & Diagnostics": [
    "Arduino",
    "Microcontroller Programming",
    "RTC Modules",
    "Wi-Fi Integration",
    "OBD-II Scanning",
    "Fault Detection",
    "Component Replacement"
  ],
  "Software & Web Development": [
    "JavaScript",
    "HTML/CSS",
    "Java",
    "IntelliJ",
    "GitHub",
    "Python",
    "MATLAB"
  ],
  "Electrical Engineering": [
    "Circuit Analysis",
    "Troubleshooting",
    "Signal Processing",
    "Motor Control",
    "Sensor Integration",
    "PWM Control"
  ]
};
